import ProductTemplate from "../../Biscuits-Template/Template";
import BisImg from "../../../assets/products/rolls/orange rolls.png";
import BiscuitImg from "../../../assets/products/rolls/Orange-Roll.png";
import { Helmet } from "react-helmet-async";

const BiscuitData = [
  {
    grams: 4,
  },
  {
    grams: 15,
  },
  {
    grams: 18,
  },
];

export default function OrangeRollProduct() {
  return (
    <>
      <Helmet>
        <title>Orange Roll – BearBitz | Premium Biscuits & Rolls</title>
        <meta
          name="description"
          content="Explore BearBitz Orange Rolls — crispy rolled wafers with zesty orange cream filling. View pack sizes and specs."
        />
        <meta name="keywords" content="Orange Roll, BearBitz Orange Roll" />
        <link rel="canonical" href="https://www.bearbitz.in/rolls/orangeroll" />
        <meta property="og:title" content="Orange Roll – BearBitz" />
        <meta
          property="og:description"
          content="Crispy rolled wafer dessert filled with orange-flavored cream by BearBitz, made for premium quality."
        />
      </Helmet>

      <ProductTemplate
        productTitle="ORANGE"
        productImage={BisImg}
        description="Rolled for Flavor, Baked for Crunch Delicious cylindrical wafer rolls packed with rich cream fillings, offering a delightful crunch with every bite. Available in various tempting flavors, they make for a premium snacking experience and a perfect pairing with beverages. Popular in gift packs and premium retail shelves across global markets."
        tableData={BiscuitData}
        BiscuitLogo={BiscuitImg}
        textColor="#EF5608"
        sectionBgColor="#FFDAC8"
        productBgcolor="#FEB088"
        tableheadBgcolor="#EF5608"
        tableBgcolor="#FFFAF7"
        footerBgcolor="#EF5608"
      />
    </>
  );
}
